import { CircularProgress } from '@mui/material';

const Loader = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '80vh',
      width: '100%',
    }}
  >
    <CircularProgress color="inherit" />
  </div>
);

export default Loader;
